export default {
	REGEX_PATTERN: /^[A-Z]{6}-?\d{9}$/g,
};
